// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3FI98","selected":"Chip_selected__1qvSg"};